import { Injectable } from '@angular/core';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IRtpSendTransaction } from '../../interfaces/send-payment/rtp-send-payment.interface';
import { AbstractRtpSendPaymentService } from '../abstraction/abstract.rtp-send-payment.service';

@Injectable({
  providedIn: 'root',
})
export class MockRtpSendPaymentService extends AbstractRtpSendPaymentService {
  sendTransaction(_transaction: IRtpSendTransaction): Promise<IWebMessage | undefined> {
    return Promise.resolve({
      status: 'Success',
      message: 'The RTP credit transfer was successfully submitted. Ref #: 20260406RTP00001',
      object: null,
    });
  }
}
